var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClickCoursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.67163 1.9116C6.52869 1.37813 5.98035 1.06155 5.44688 1.20449C4.91342 1.34743 4.59684 1.89577 4.73978 2.42923L4.9986 3.39516C5.14154 3.92863 5.68988 4.24521 6.22334 4.10227C6.75681 3.95932 7.07339 3.41099 6.93045 2.87752L6.67163 1.9116Z",
    fill: "#4318FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42899 4.74002C1.89552 4.59708 1.34719 4.91366 1.20424 5.44713C1.0613 5.9806 1.37788 6.52893 1.91135 6.67187L2.87728 6.93069C3.41074 7.07363 3.95908 6.75705 4.10202 6.22359C4.24496 5.69012 3.92838 5.14178 3.39491 4.99884L2.42899 4.74002Z",
    fill: "#4318FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2424 4.17162C11.633 3.78109 11.633 3.14793 11.2424 2.7574C10.8519 2.36688 10.2187 2.36688 9.82823 2.7574L9.12112 3.46451C8.73059 3.85503 8.73059 4.4882 9.12112 4.87872C9.51164 5.26925 10.1448 5.26925 10.5353 4.87872L11.2424 4.17162Z",
    fill: "#4318FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17137 11.2427L4.87848 10.5356C5.269 10.1451 5.269 9.51189 4.87848 9.12136C4.48795 8.73084 3.85479 8.73084 3.46427 9.12136L2.75716 9.82847C2.36663 10.219 2.36663 10.8522 2.75716 11.2427C3.14768 11.6332 3.78085 11.6332 4.17137 11.2427Z",
    fill: "#4318FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3713 6.07164C6.99988 5.92307 6.57566 6.01015 6.2928 6.29301C6.00994 6.57587 5.92286 7.00009 6.07143 7.37151L10.0714 17.3715C10.2177 17.7371 10.5649 17.9829 10.9583 17.9993C11.3518 18.0156 11.7182 17.7995 11.8943 17.4473L13.2739 14.6883L16.2928 17.7072C16.6833 18.0977 17.3165 18.0977 17.707 17.7072C18.0975 17.3167 18.0975 16.6835 17.707 16.293L14.6881 13.2741L17.4471 11.8945C17.7993 11.7184 18.0154 11.352 17.999 10.9586C17.9827 10.5651 17.7369 10.2179 17.3713 10.0716L7.3713 6.07164Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickCoursor);
export default __webpack_public_path__ + "static/media/click-coursor.de156e40537fea3944b0c650e68e4af9.svg";
export { ForwardRef as ReactComponent };